import React from 'react';
import { isDemoMode } from '../utils/demoMode';

const DemoBanner = () => {
  if (!isDemoMode) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        zIndex: 10000,
        background: '#212121',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.05em',
        padding: '4px 10px',
        borderRadius: 4,
        opacity: 0.75,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      DEMO
    </div>
  );
};

export default DemoBanner;
